import { useState } from "react";
import CustomDialogSmall from "../../../components/Dialog/DiaCompSmall";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
//import VaccinesIcon from '@mui/icons-material/Vaccines';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';




export default function DiaGetLabs() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
  
        <Tooltip title="List of contracted labs" placement="left">
            <IconButton onClick={handleOpen} sx={{color:'primary.dark', bgcolor: 'primary.C100', '&:hover': {transform: 'scale(1.2)'}, }} >
                <TransferWithinAStationIcon sx={{color: 'common.blacl', '&:hover': { transform: 'scale(1.1)'}, }}/>
            </IconButton>   
        </Tooltip>
   
    <CustomDialogSmall open={open} onClose={handleClose}

          title="Contracted speak23 Laboratories"
         
          content = "List of contracted labs - soon ..."

        />
        
</>
)}